<div class="eui-autocomplete__container" matAutocompleteOrigin #origin="matAutocompleteOrigin">
    <div class="eui-autocomplete__wrapper eui-autocomplete__wrapper--{{ chipsPosition }}">

        <ng-template [ngIf]="chipsPosition === 'bottom'">
            <ng-container *ngTemplateOutlet="field"></ng-container>
        </ng-template>

        <ng-container *ngIf="hasChips">
            <eui-chip-list
                [chips]="chips"
                [isChipsDragAndDrop]="isChipsDragAndDrop"
                [isChipsRemovable]="isChipsRemovable && !readonly"
                [isChipsSorted]="isChipsSorted"
                [chipsSortOrder]="chipsSortOrder"
                [maxVisibleChipsCount]="maxVisibleChipsCount"
                [isMaxVisibleChipsOpened]="isMaxVisibleChipsOpened"
                [toggleLinkMoreLabel]="toggleLinkMoreLabel"
                [toggleLinkLessLabel]="toggleLinkLessLabel"
                [chipsLabelTruncateCount]="chipsLabelTruncateCount"
                [dragAndDropSourceName]="dragAndDropSourceName"
                [dragAndDropConnectedTo]="dragAndDropConnectedTo"
                (chipDropped)="onChipDropped($event)"
                (chipDragStarted)="onChipDragStarted($event)"
                (chipDragReleased)="onChipDragReleased($event)"
                (chipRemove)="onChipRemove($event)"
                (chipsInit)="chipsInit($event)">
                <euiChipListAppendContent>
                    <ng-template [ngIf]="chipsPosition === 'inside'">
                        <ng-container *ngTemplateOutlet="field"></ng-container>
                    </ng-template>
                </euiChipListAppendContent>
            </eui-chip-list>
        </ng-container>

        <ng-template [ngIf]="chipsPosition === 'top' || !hasChips">
            <ng-container *ngTemplateOutlet="field"></ng-container>
        </ng-template>

        <ng-template #field>
            <span class="eui-autocomplete__field-wrapper">

                <ng-content select="euiAutocompletePrependContent"></ng-content>

                <div class="eui-clearable-input-wrapper">
                    <ng-container *ngIf="!hasChips">
                        <input
                            #autocompleteInput
                            #autocompleteInputTrigger
                            placeholder="{{ placeholder }}"
                            [matAutocompleteDisabled]="readonly"
                            [formControl]="autocompleteControl"
                            [matAutocomplete]="auto"
                            [class.input-addon--prepend]="euiAutocompletePrependContent"
                            [class.input-addon--append]="euiAutocompleteAppendContent"
                            (click)="onClick($event)"
                            (focusout)="resetNbClick($event)"
                            [attr.aria-label]="placeholder ? placeholder : 'Autocomplete Input Field'">
                    </ng-container>
                    <ng-container *ngIf="chipsListComponent && hasChips">
                        <input
                            #autocompleteInput
                            #autocompleteInputTrigger
                            placeholder="{{ placeholder }}"
                            [matAutocompleteDisabled]="readonly"
                            [formControl]="autocompleteControl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipsListComponent"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            [matAutocompleteConnectedTo]="chipsPosition === 'inside' ? origin : null"
                            [class.input-addon--prepend]="euiAutocompletePrependContent"
                            [class.input-addon--append]="euiAutocompleteAppendContent"
                            (click)="onClick($event)"
                            (focusout)="resetNbClick($event)"
                            (matChipInputTokenEnd)="add($event)"
                            [attr.aria-label]="placeholder ? placeholder : 'Autocomplete Input Field'">
                    </ng-container>
                    <span class="eui-clearable-input-wrapper__clear" (click)="clearInput()" *ngIf="autocompleteControl.value && autocompleteControl.value.length > 0 && !isLoading && !readonly"></span>
                    <span class="eui-autocomplete__loading-indicator" *ngIf="isLoading"></span>
                </div>

                <ng-content select="euiAutocompleteAppendContent"></ng-content>

                <mat-autocomplete
                    #auto="matAutocomplete"
                    [panelWidth]="panelWidth"
                    [class]="classList"
                    (closed)="onClose()"
                    (opened)="onOpen()"
                    (optionSelected)="onOptionSelected($event)">
                    <ng-container *ngIf="groupBy">
                        <ng-container *ngFor="let distinctOptionGroup of distinctOptionGroups">
                            <mat-optgroup
                                [class.eui-autocomplete__optgroup--custom]="autocompleteOptGroupTemplate"
                                *ngIf="(groupedItems[distinctOptionGroup] | async).length > 0"
                                [label]="distinctOptionGroup">
                                <ng-container *ngIf="autocompleteOptGroupTemplate">
                                    <div class="eui-autocomplete__optgroup--custom-optgroup-wrapper">
                                        <ng-template [ngTemplateOutlet]="autocompleteOptGroupTemplate" [ngTemplateOutletContext]="{ $implicit: { label: distinctOptionGroup } }"></ng-template>
                                    </div>
                                </ng-container>
                                <mat-option
                                    *ngFor="let groupedItem of groupedItems[distinctOptionGroup] | async; trackBy: trackByFn"
                                    [class]="groupedItem.typeClass ? 'mat-option eui-autocomplete__option eui-autocomplete__option--' + groupedItem.typeClass : 'mat-option eui-autocomplete__option'"
                                    [class.eui-autocomplete__option--custom]="autocompleteOptionTemplate"
                                    [value]="groupedItem">
                                    <span *ngIf="groupedItem.iconClass" class="{{ groupedItem.iconClass }}"></span>
                                    <ng-container *ngIf="!autocompleteOptionTemplate">
                                        {{ groupedItem.label }}
                                    </ng-container>
                                    <ng-container *ngIf="autocompleteOptionTemplate">
                                        <ng-template [ngTemplateOutlet]="autocompleteOptionTemplate" [ngTemplateOutletContext]="{ $implicit: groupedItem }"></ng-template>
                                    </ng-container>
                                </mat-option>
                            </mat-optgroup>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!groupBy">
                        <mat-option
                            *ngFor="let autocompleteOption of autocompleteOptions | async; trackBy: trackByFn"
                            [class]="autocompleteOption.typeClass ? 'mat-option eui-autocomplete__option eui-autocomplete__option--' + autocompleteOption.typeClass : 'mat-option eui-autocomplete__option'"
                            [class.eui-autocomplete__option--custom]="autocompleteOptionTemplate"
                            [value]="autocompleteOption">
                            <span *ngIf="autocompleteOption.iconClass" class="{{ autocompleteOption.iconClass }}"></span>
                            <ng-container *ngIf="!autocompleteOptionTemplate">
                                {{ autocompleteOption.label }}
                            </ng-container>
                            <ng-container *ngIf="autocompleteOptionTemplate">
                                <ng-template [ngTemplateOutlet]="autocompleteOptionTemplate" [ngTemplateOutletContext]="{ $implicit: autocompleteOption }"></ng-template>
                            </ng-container>
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
            </span>
        </ng-template>

    </div>
</div>
